import { z } from 'zod';

import { isoDatetimeToDate } from '../codecs';

export type UserPlayerMappingId = UserPlayerMapping['id'];

export type UserPlayerMapping = z.output<typeof userPlayerMappingSchema>;
export type UserPlayerMappingDTO = z.input<typeof userPlayerMappingSchema>;

export const userPlayerMappingSchema = z.object({
  id: z.uuid(),
  createdAt: isoDatetimeToDate,
  updatedAt: isoDatetimeToDate,
  playerId: z.uuid(),
  userId: z.uuid(),
});
